import React, { useContext } from 'react';
import { t } from 'i18next';
import { Collapsible } from '@sentara-health/optimahealth_web';
import { useForm } from 'react-hook-form';
import { PhoneNotificationProps } from './interface';
import { EmailPaperless } from 'templates';
import CommunicationChannels from './CommunicationChannels';
import { useDeviceType, DeviceTypes } from 'common';
import TextNotificationWrapper from './TextNotificationWrapper'; // Ensure correct import
import { GlobalContext } from '../../context'; // Import GlobalContext

const PhoneNotifications = ({
  smsConsent,
  setState,
  state,
  expand = true,
  onExpand,
  onCollapse,
}: PhoneNotificationProps) => {
  const {
    formState: { isValid, errors },
  } = useForm({});

  const { getFeature } = useContext(GlobalContext); // Access global feature flags

  const emailConsent = getFeature?.EmailConsent ?? false;
  const textNotificationsFeature = getFeature?.TextNotifications ?? false;
  const communicationChannelFeature = getFeature?.CommunicationChannel ?? false;

  const deviceType = useDeviceType();
  const isMobile = deviceType === DeviceTypes.MOBILE;

  return (
    <Collapsible
      title={t('profile.communicationPreference')}
      id={'phoneNotifications'}
      isMobile={isMobile}
      key={`${'phoneNotifications'}-${isMobile ? 'mobile' : 'desktop'}`}
      expand={expand}
      onExpand={onExpand}
      onCollapse={onCollapse}
      className="mb-3 pb-2"
    >
      <div className="set_my_preferences">
        <div className="user_address_wrapper border_wrapper">
          {textNotificationsFeature && (
            <TextNotificationWrapper
              smsConsent={smsConsent}
              setState={setState}
              state={state}
              // cancelConsentProp={() => {}}
            />
          )}
          {communicationChannelFeature && (
            <CommunicationChannels
              smsConsent={smsConsent}
              state={state}
              setState={setState}
            />
          )}
          {emailConsent && (
            <EmailPaperless
              key={`emailPaperless-$`}
              state={state}
              setState={setState}
            />
          )}
        </div>
      </div>
    </Collapsible>
  );
};

export default PhoneNotifications;
